import { ArrowLeftOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useHistory } from "react-router-dom";
import WpsReportTableAgGrid from "./Wps-limit-table";

const HotPassTabledata360live = () => {
  const location = useLocation();
  const history = useHistory();

  const { passname, weld_number } = location.state || {};
  const queryParams = new URLSearchParams(location.search);
  const boundary = queryParams.get("boundary");
  const pqrData = useSelector((state) => state?.data360LivePqrReducer);
  const wpsLimitDataRecords = pqrData?.data?.records?.[passname] || [];

  const handleRowClick = (record) => {
    history.push(
      `/data360-live-tlog-data/${record.passName}?boundary=${boundary}`,
      {
        weld_no: record.weldNumber,
        Bugtype: record.torch || "iwm",
        deviceid: record.welduid_s_event_torch,
        s_deviceid_event: record.welduid_s_event_torch,
        weldNumber: weld_number,
        weld_number: weld_number,
        type: record.torch,
        bugTypepqr: record.bugType,
        passn: passname,
        station_number: record.station_number,
      }
    );
  };

  return (
    <div>
      <div className="slogweld-title">
        <Link to={`/data360Live/pqr-report`}>
          <div className="back_equip">
            <Tooltip title={"Back"}>
              <ArrowLeftOutlined />
            </Tooltip>
            <h2 className="slogweld-header-active">PQR Report</h2>
          </div>
        </Link>
        <Link
          to={`/data360-live-pqr-table-data/${weld_number}?boundary=${boundary}`}
        >
          <div className="back_equip">
            <Tooltip title={"Back"}>
              <ArrowLeftOutlined />
            </Tooltip>
            <h2 className="slogweld-header-active">Weld {weld_number}</h2>
          </div>
        </Link>
        <div className="back_equip-unActive">
          <ArrowLeftOutlined />
          <h2 className="slogweld-header">{passname}</h2>
        </div>
      </div>
      <WpsReportTableAgGrid
        handleRowClick={handleRowClick}
        rows={wpsLimitDataRecords}
        isLoading={false}
      />
    </div>
  );
};

export default HotPassTabledata360live;
